// utils.js 또는 해당 파일

function make(tagName, classNames = null, attributes = {}) {
    const el = document.createElement(tagName);

    if (Array.isArray(classNames)) {
        // classNames가 배열일 경우 (이전과 동일)
        el.classList.add(...classNames);
    } else if (classNames) {
        // ✨ 이 부분이 수정되었습니다.
        // classNames가 문자열일 경우, 공백을 기준으로 잘라서 개별 클래스로 추가합니다.
        // 이렇게 하면 "relative mt-4" 같은 Tailwind 클래스 문자열을 올바르게 처리할 수 있습니다.
        el.classList.add(...classNames.split(' ').filter(Boolean));
    }

    for (const attrName in attributes) {
        if (attrName === 'htmlFor') {
            el.htmlFor = attributes[attrName];
        } else {
            el[attrName] = attributes[attrName];
        }


    }

    return el;
}


function isPromise(object) {
    return object && typeof object.then === 'function';
}

const linkCheck = (str) => {
    if (!str || typeof str !== 'string') {
        return false;
    }
    // eslint-disable-next-line
    const pattern = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
    return pattern.test(str);
};

const isValidImageUrl = (urlString) => {
    if (!urlString || typeof urlString !== 'string') {
        return false;
    }
    return /^(https?:\/\/)/.test(urlString);
};

const CODE_LANGUAGES = [
    'text', 'python', 'cpp', 'c', 'java', 'csharp', 'javascript', 'go', 'vb', 'pascal', 'sql',
    'fortran-free-form', 'r', 'ada', 'php', 'rust', 'asm', 'swift', 'typescript', 'kotlin',
    'ruby', 'html', 'css', 'scss', 'sass', 'shellscript', 'bash', 'sh', 'powershell', 'dart', 'markdown', 'json', 'yaml',
    'graphql', 'docker', 'tsx', 'jsx', 'lua', 'perl', 'scala', 'objective-c', 'haskell',
    'clojure', 'elixir', 'vue', 'erb', 'dotenv', 'latex', 'xml', 'make', 'makefile'
];

const EditorJsControlKeys = new Set([
    'Backspace',
    'Delete',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Enter',
    '/', 'Slash', 'Tab'
]);

function stopPropagationOnEditorJsControlKeys(event) {
    if (EditorJsControlKeys.has(event.key)) {
        event.stopPropagation();
    }
}


export { make, isPromise, linkCheck, isValidImageUrl, stopPropagationOnEditorJsControlKeys, CODE_LANGUAGES };